import React from "react"
import { makeStyles } from "@material-ui/core/styles"

import FormContainer from "../../components/FormContainer"
import Layout from "../../components/PublicLayout"

const useStyles = makeStyles(() => ({
  lititle: {
    marginBottom: 0,
  },
  licontent: {
    marginTop: 0,
  },
}))

export default function Landing() {
  const classes = useStyles()

  return (
    <Layout title="Condo Axis">
      <FormContainer>
        <h2>Welcome to Condo Axis!</h2>
        <strong>AFFORDABLE AND COMPREHENSIVE ASSOCIATION MANAGEMENT SOLUTION</strong>
        <p>
          We are currently beta testing, and are invite-only. To get an invitation, email{" "}
          <a href="mailto:beta@condoaxis.com">beta@condoaxis.com</a>.
        </p>
        <div>
          <div>
            <h4 className={classes.lititle}>01</h4>
            <p className={classes.licontent}>Store governing documents</p>
          </div>
          <div>
            <h4 className={classes.lititle}>02</h4>
            <p className={classes.licontent}>Up-to-the-minute budget and financial updates</p>
          </div>
          <div>
            <h4 className={classes.lititle}>03</h4>
            <p className={classes.licontent}>Communicate with all unit owners instantly</p>
          </div>
          <div>
            <h4 className={classes.lititle}>04</h4>
            <p className={classes.licontent}>Vote on association matters</p>
          </div>
          <div>
            <h4 className={classes.lititle}>05</h4>
            <p className={classes.licontent}>
              Generate and distribute resale documents immediately
            </p>
          </div>
        </div>
      </FormContainer>
    </Layout>
  )
}
